import { getVueInstance } from './vue-instance'
import { canOpenPageByWebUrl, isFromBDAPP } from '@/utils/bridge/fromBDAPP'
import vueI18n from '@/i18n/locale'
import store from '@/store'
import { versionSemverGte } from '@/utils/common/utils'
export function getGlobalParams() {
  if (Soda.getGlobalParams) {
    try {
      return SodaBridge('getGlobalParams', 'badcase')
        .then(resp => {
          return getBridgeData(resp)
        })
        .catch(e => {
          console.log(e)
          console.log('==getGlobalParams error')
        })
    } catch (e) {
      console.log(e)
      console.log('getGlobalParams error')
    }
  }
  return {}
}

// 用户信息
export function getUserInfo() {
  return SodaBridge('merchant.getUserInfo', 'badcase').then(resp => getBridgeData(resp))
}

// 门店信息
export function getShopInfo() {
  return SodaBridge('merchant.getShopInfo', 'badcase').then(resp => getBridgeData(resp))
}

export function getContractorInfo() {
  return SodaBridge('merchant.getContractorInfo', 'badcase').then(resp => getBridgeData(resp))
}

export function openPage(data) {
  // TODO: [BDAPP] 在BDAPP上线openPage方案之前需要兼容(使用浏览器默认history)
  const { appVersion } = store?.state?.globalParams || {}
  const GTVersion = versionSemverGte(appVersion, '1.3.2')
  if (isFromBDAPP() && !GTVersion) {
    const url = data?.url
    if (canOpenPageByWebUrl(url)) {
      location.href = url
    } else {
      const vueInstance = getVueInstance()
      const toast = vueInstance.$createGoToast({
        // TODO: [BDAPP] 更新文案
        txt: vueI18n.t('Gattaran_app_wQyy_gBIH', { app: 'Explorer' }), // 此功能只能在商家端使用，{{app}}暂不支持
        type: 'correct',
      })
      toast.show()
    }
    return Promise.resolve({})
  } else {
    return SodaBridge('openPage', data).then(resp => getBridgeData(resp))
  }
}

export function closePage(data) {
  // TODO: [BDAPP] 在BDAPP上线openPage方案之前需要兼容(使用goBack)
  const { appVersion } = store?.state?.globalParams || {}
  const GTVersion = versionSemverGte(appVersion, '1.3.2')
  if (isFromBDAPP() && !GTVersion) {
    return goBack()
  } else {
    return SodaBridge('closePage', data).then(resp => getBridgeData(resp))
  }
}

export function setTitle(naviTitle) {
  return new Promise(resolve => {
    setTimeout(() => {
      SodaBridge('setTitle', {
        navi_title: naviTitle,
      })
      resolve()
    }, 300)
  })
}

// 新店引导
export function showGuide(data) {
  return SodaBridge('merchant.showGuide', data).then(resp => {
    getBridgeData(resp)
  })
}

// 拦截native返回键 listen为true拦截，false为取消拦截，callback为拦截后执行函数
export function setBackPressListener(state, callback) {
  if (isFromBDAPP()) {
    // TODO: [BDAPP] 在BDAPP与BH5的bridge入参不一致，需要兼容参数
    window.Soda &&
      window.Soda.setBackPressListener &&
      window.Soda.setBackPressListener(state, callback)
  } else {
    return SodaBridge('setBackPressListener', { listen: state })
      .then(() => {
        callback()
      })
      .catch(() => {})
  }
}

function getBridgeData(resp = {}) {
  const { errno = 0 } = resp
  if (errno.toString() === '0') {
    return resp.data || resp
  }
}
export function addPhotoBridge(config = {}) {
  return SodaBridge(
    isFromBDAPP() ? 'manager.addPhotoBridge' : 'merchant.addPhotoBridge',
    config,
  ).then(resp => {
    return getBridgeData(resp)
  })
}

export function goBack(data) {
  return SodaBridge('goBack', data).then(resp => getBridgeData(resp))
}

export function openPicEditPage(config) {
  return SodaBridge('manager.openPicEditPage', config).then(resp => getBridgeData(resp))
}
export function openNewStoreGrowthTip(config) {
  return SodaBridge('merchant.getNewStoreGrowthRemindInfo', config).then(resp =>
    getBridgeData(resp),
  )
}

export function openBrowser(config) {
  return SodaBridge('merchant.openBrowser', config).then(resp => getBridgeData(resp))
}

// 下载文件 目前只支持图片
export function downloadFile(params) {
  let msg = ''
  console.log(params, '---downloadFile 传参')
  return SodaBridge('merchant.downloadFile', params)
    .then(resp => {
      getBridgeData(resp)
      msg = vueI18n.t('FoodB_202403_tIbT_QIhv' /* 已下载成功 */)
    })
    .catch(res => {
      const { errno } = res
      console.log(res, '----bridge异常返回')
      if (errno === 101) {
        msg = vueI18n.t('FoodB_202403_iElx_PrgH' /* 无访问相册权限，请您开启权限后重试 */)
      } else {
        msg = vueI18n.t('FoodB_202403_Oupx_AERj' /* 下载失败，请您重试 */)
      }
    })
    .finally(() => {
      const vueInstance = getVueInstance()
      const toast = vueInstance.$createGoToast({
        txt: msg,
        type: 'txt',
      })
      toast.show()
    })
}

// 设置顶栏状态
export function setTitleBarVisibility(isVisible) {
  return SodaBridge('setTitleBarVisibility', {
    isVisible,
  })
}
